module.exports = __webpack_public_path__ + "static/achieveIcon_2-132c2733e945b808d8fbca5beb61476c.png";